import React, { useEffect, useMemo, useState } from "react";
import { Button, Checkbox, Col, Form, Input, Row, message } from "antd";
import "../../styles/booking-config-page.style.scss";
import { isValid } from "../../utils/utilities";
import { getReservationDetailsByOperatorCode, updateReservationDetailsByOperatorCode } from "../../actions/admin.action";

export const BookingConfigPage = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [restrictCombined, setRestrictCombined] = useState(false);

    const operatorCode = useMemo(() => {
        return global?.operatorCode || global?.operator_code;
    }, []);

    useEffect(() => {
        if (!isValid(operatorCode)) return;

        setLoading(true);
        getReservationDetailsByOperatorCode(
            operatorCode,
            (data) => {
                const combinedValue = data?.maximum_ladies_reservation ?? null;
                const seaterValue = data?.maximum_seater_ladies_reservation ?? null;
                const sleeperValue = data?.maximum_sleeper_ladies_reservation ?? null;

                const isCombinedEnabled = combinedValue !== null && combinedValue !== undefined && `${combinedValue}`.trim() !== "";
                setRestrictCombined(isCombinedEnabled);

                form.setFieldsValue({
                    restrictCombined: isCombinedEnabled,
                    maximum_ladies_reservation: combinedValue,
                    maximum_seater_ladies_reservation: seaterValue,
                    maximum_sleeper_ladies_reservation: sleeperValue
                });
                setLoading(false);
            },
            (errmsg) => {
                message.error(errmsg);
                setLoading(false);
            }
        );
    }, [operatorCode]);

    const normalizeValue = (v) => {
        if (v === undefined || v === null) return null;
        if (typeof v === "string" && v.trim() === "") return null;
        return v;
    };

    const onFinish = (values) => {
        if (!isValid(operatorCode)) {
            message.error("Operator code missing");
            return;
        }

        const combined = normalizeValue(values.maximum_ladies_reservation);
        const seater = normalizeValue(values.maximum_seater_ladies_reservation);
        const sleeper = normalizeValue(values.maximum_sleeper_ladies_reservation);

        const payload = values.restrictCombined
            ? {
                maximum_ladies_reservation: combined,
                maximum_seater_ladies_reservation: null,
                maximum_sleeper_ladies_reservation: null
            }
            : {
                maximum_ladies_reservation: null,
                maximum_seater_ladies_reservation: seater,
                maximum_sleeper_ladies_reservation: sleeper
            };

        setLoading(true);
        updateReservationDetailsByOperatorCode(
            operatorCode,
            payload,
            (msg) => {
                message.success(msg || "Updated successfully");
                setRestrictCombined(!!values.restrictCombined);
                setLoading(false);
            },
            (errmsg) => {
                message.error(errmsg);
                setLoading(false);
            }
        );
    };

    return (
        <div className="booking-config-page">
            <div className="booking-config-card">
                <h2 className="booking-config-title">Ladies Seat Restriction</h2>

                <Form
                    form={form}
                    initialValues={{ restrictCombined: false }}
                    onFinish={onFinish}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item name="restrictCombined" valuePropName="checked">
                        <Checkbox
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setRestrictCombined(checked);
                                if (checked) {
                                    form.setFieldsValue({
                                        maximum_seater_ladies_reservation: null,
                                        maximum_sleeper_ladies_reservation: null
                                    });
                                } else {
                                    form.setFieldsValue({
                                        maximum_ladies_reservation: null
                                    });
                                }
                            }}
                        >
                            Restrict for all seat types combined
                        </Checkbox>
                    </Form.Item>

                    <div className="booking-config-subtitle">Max no. of ladies seat</div>

                    {restrictCombined ? (
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={12} md={10}>
                                <Form.Item name="maximum_ladies_reservation">
                                    <Input disabled={loading} />
                                </Form.Item>
                                <div className="booking-config-field-label">Seaters/Sleepers combined</div>
                            </Col>
                        </Row>
                    ) : (
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={12} md={10}>
                                <Form.Item name="maximum_seater_ladies_reservation">
                                    <Input disabled={loading} />
                                </Form.Item>
                                <div className="booking-config-field-label">Seaters</div>
                            </Col>
                            <Col xs={24} sm={12} md={10}>
                                <Form.Item name="maximum_sleeper_ladies_reservation">
                                    <Input disabled={loading} />
                                </Form.Item>
                                <div className="booking-config-field-label">Sleepers</div>
                            </Col>
                        </Row>
                    )}

                    <Row style={{ marginTop: 12 }}>
                        <Col>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                Update
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    );
};

